<template>
  <div>
    <span
      style="cursor: pointer; padding: 5px; position: absolute; right: 0; top: -10px"
      @click="toggleModal"
    >
      <b-icon-filter-circle-fill
        scale="1.5"
        :class="{ 'text-primary': hasFiltersActive }"
      />
    </span>

    <b-modal id="users-filters-modal" no-close-on-esc no-close-on-backdrop>
      <template #modal-title>
        <h5 class="modal-title text-capitalize text-white">
          {{ $t("alarm_views.users") }}
        </h5>
      </template>
      <b-row>
        <b-col cols="6" class="my-1 mb-md-0">
          <b-form-group
            class="text-capitalize"
            :label="$tc('profiles.title', 2)"
            label-for="id_profiles"
          >
            <v-select
              v-model="profileId"
              @input="onChangeProfile"
              :options="profileOptions"
              :reduce="(val) => val.value"
              :close-on-select="true"
              input-id="id_profiles"
              :placeholder="$t('alarm_views.profile_placeholder')"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" class="my-1 mb-md-0" v-if="hasFiltersActive">
          <p>{{ $t("alarm_views.users_found") }}: {{ totalUsersFiltered }}</p>
        </b-col>
      </b-row>
      <template #modal-footer="{ close }">
        <div class="w-100 rfm-footer">
          <div class="d-flex flex-row align-items-stretch justify-content-between">
            <b-button
              variant="danger"
              class="mr-2 mb-0"
              @click="cleanFilters"
              :disabled="!hasFiltersActive"
            >
              {{ $t("alarm_views.btns.clear_filters") }}
            </b-button>
            <b-button-group>
              <b-dropdown
                right
                :text="$t('alarm_views.btns.options')"
                variant="primary"
                :disabled="!hasFiltersActive || totalUsersFiltered == 0"
              >
                <b-dropdown-item @click="filterUsers">{{
                  $t("alarm_views.btns.filter_results")
                }}</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="selectUsers">{{
                  $t("alarm_views.btns.select")
                }}</b-dropdown-item>
                <b-dropdown-item @click="removeUsers">{{
                  $t("alarm_views.btns.remove")
                }}</b-dropdown-item>
              </b-dropdown>
            </b-button-group>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { ref, computed, watch } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";

export default {
  components: {
    vSelect,
  },
  props: {
    usersSelected: {
      type: Array,
      default: () => [],
    },
    userOptions: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { root, emit }) {
    const profileId = ref(null);
    const usersFiltered = ref([]);
    const usersFilteredWithSelected = ref([]);
    const totalUsersFiltered = ref(0);

    const toggleModal = () => {
      root.$bvModal.show("users-filters-modal");
    };

    store.dispatch("profile/getAll");

    const profileOptions = computed(() =>
      store.getters["profile/getItems"].map((profile) => {
        return {
          ...profile,
          value: profile.id,
          label: profile.type,
        };
      })
    );

    const onChangeProfile = (value) => {
      if (!value) {
        totalUsersFiltered.value = 0;
        usersFiltered.value = [];
        usersFilteredWithSelected.value = [];
      }

      // para mantener en el select los usuarios seleccionados y los que pertenecen al perfil
      usersFilteredWithSelected.value = props.userOptions.filter((user) => {
        return user.id_profile == value || props.usersSelected.includes(user.value);
      });

      // para filtrar los usuarios que pertenecen al perfil
      usersFiltered.value = props.userOptions.filter((user) => {
        return user.id_profile == value;
      });

      totalUsersFiltered.value = usersFiltered.value.length;
    };

    const cleanFilters = () => {
      profileId.value = null;
      usersFiltered.value = [];
      usersFilteredWithSelected.value = [];
      totalUsersFiltered.value = 0;

      emit("users-filtered", []);

      root.$bvModal.hide("users-filters-modal");
    };

    const filterUsers = () => {
      emit("users-filtered", usersFilteredWithSelected.value);

      root.$bvModal.hide("users-filters-modal");
    };

    const selectUsers = () => {
      const currentUsersSelected = props.usersSelected;
      const usersSelected = usersFiltered.value.map((user) => user.value);

      const newUsersSelected = [...currentUsersSelected, ...usersSelected];
      const usersSet = new Set(newUsersSelected);
      const newUniqueUsers = [...usersSet];

      emit("users-selected", newUniqueUsers);

      cleanFilters();
    };

    const removeUsers = () => {
      const usersFilteredIds = usersFiltered.value.map((user) => user.id);
      const usersSelected = props.usersSelected.filter(
        (id) => !usersFilteredIds.includes(id)
      );

      emit("users-selected", usersSelected);

      cleanFilters();
    };

    const hasFiltersActive = computed(() => profileId.value);

    return {
      profileId,
      toggleModal,
      profileOptions,
      onChangeProfile,
      cleanFilters,
      filterUsers,
      selectUsers,
      totalUsersFiltered,
      hasFiltersActive,
      removeUsers,
    };
  },
};
</script>

